const projectInfoTools = {
    size: $(window).outerWidth() < 1024 ? 'mob' : 'desk',
    wrapper: $('.js_project-info__wrapper'),

    init: function () {
        if ($(window).outerWidth() < 1024) {
            projectInfoTools.wrapper.each((i, el) => {
                const element = $(el).find('.js_project-info__main')
                const mob = $(el).find('.js_project-info__main-mob')
                mob.append(element)
            })
        }
    },

    adapt: function () {
        const width = $(window).outerWidth()
        projectInfoTools.wrapper.each((i, el) => {
            const element = $(el).find('.js_project-info__main')
            const desk = $(el)
            const mob = $(el).find('.js_project-info__main-mob')
            if (width < 1024 && projectInfoTools.size == 'desk') {
                projectInfoTools.size = 'mob'
                mob.append(element)
            } else if (width >= 1024 && projectInfoTools.size == 'mob') {
                projectInfoTools.size = 'desk'
                desk.prepend(element)
            }
        })
    }
}

$(document).ready(() => {
    projectInfoTools.init()
})

$(window).on('resize', () => {
    projectInfoTools.adapt()
})